/**
 * @fileoverview Entry point for the offline mode server.
 * This module initializes the Mirage server for offline mode.
 * It imports the server setup from the 'server' module and exports a loader function.
 * The loader function is used to dynamically import the server setup when needed.
 * This allows for lazy loading of the server setup, which can help reduce the initial load time
 * of the application when offline mode is not required.
 * @module offline/index
 */
const offlineServerLoader = async () => {
        const module = await import('./server' /* webpackChunkName: "offlinemode" */);
        module.initOfflineServer();
}

export default offlineServerLoader;